import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { UiButtonGroup, UiButton } from 'ui-components';
import { changeChartTimeGap } from 'store';
import { useTranslation } from 'react-i18next';
import { useUpdateEffect } from 'hooks';

const TimeGap = ({
  onSubmit,
  timeGaps,
  page,
  platform,
  boxName,
  titles = [],
  disabled,
  defaultTimeGap = 'hour',
}) => {
  const dispatch = useDispatch();
  const selectedTimeGap =
    useSelector((state) => state.chartReducer?.[page]?.[platform]?.[boxName]) ||
    defaultTimeGap;
  const availableTimeGaps = useSelector((state) => {
    switch (page) {
      case 'bulletinPDF':
        return state.chartReducer.bulletinAvailableTimeGaps;
      case 'brandBaan':
        return state.chartReducer.brandBaanAvailableTimeGaps;
      default:
        return state.chartReducer.availableTimeGaps;
    }
  });

  const { t } = useTranslation();

  if (!titles || titles.length === 0)
    titles = [
      t('statistics:hourly'),
      t('statistics:daily'),
      t('statistics:weekly'),
      t('statistics:monthly'),
    ];

  const currentTimeGaps = timeGaps || availableTimeGaps;

  /**
   * کنترل تغییر بازه
   * @param {*} type hour|day|week
   */
  const handleChange = (timeGap) => {
    dispatch(
      changeChartTimeGap({
        selectedPage: page,
        selectedPlatform: platform,
        selectedChart: boxName,
        newTimeGap: timeGap,
      })
    );
  };

  useUpdateEffect(() => {
    if (typeof onSubmit === 'function') onSubmit();
  }, [selectedTimeGap]);

  return (
    <UiButtonGroup
      value={selectedTimeGap}
      variant='outlined'
      color='primary'
      size='small'
      className='ltr'
    >
      {currentTimeGaps.includes('hour') && (
        <UiButton
          disabled={disabled?.includes('hour')}
          variant={selectedTimeGap === 'hour' ? 'contained' : 'outlined'}
          onClick={() => handleChange('hour')}
          disableElevation={false}
        >
          {titles[0]}
        </UiButton>
      )}
      {currentTimeGaps.includes('day') && (
        <UiButton
          disabled={disabled?.includes('day')}
          variant={selectedTimeGap === 'day' ? 'contained' : 'outlined'}
          onClick={() => handleChange('day')}
          disableElevation={false}
        >
          {titles[1]}
        </UiButton>
      )}
      {currentTimeGaps.includes('week') && (
        <UiButton
          disabled={disabled?.includes('week')}
          variant={selectedTimeGap === 'week' ? 'contained' : 'outlined'}
          onClick={() => handleChange('week')}
          disableElevation={false}
        >
          {titles[2]}
        </UiButton>
      )}
      {currentTimeGaps.includes('month') && (
        <UiButton
          disabled={disabled?.includes('month')}
          variant={selectedTimeGap === 'month' ? 'contained' : 'outlined'}
          onClick={() => handleChange('month')}
          disableElevation={false}
        >
          {titles[3]}
        </UiButton>
      )}
    </UiButtonGroup>
  );
};

TimeGap.propTypes = {
  onSubmit: PropTypes.func,
  page: PropTypes.string,
  boxName: PropTypes.string,
  platform: PropTypes.string,
  timeGaps: PropTypes.array,
  titles: PropTypes.array,
  disabled: PropTypes.array,
  defaultTimeGap: PropTypes.string,
};

export default TimeGap;
